import styled from 'styled-components';

export const StyledMe2onBalance = styled.div`
    display: flex;
    align-items: center;
    font-weight: 700;
    margin-right: 4px;
    color: #ffdf71;
    font-size: 20px;
    font-family: var(--font-family), Arial;

    .imgContainer {
        height: 24px;
        width: 24px;
        margin-right: 2px;

        .balanceImg {
            height: 100%;
            width: 100%;
            object-fit: contain;
        }
    }

    .playerLevelImg {
        margin-left: 8px;
        width: auto;
        height: 28px;
    }
`;
